<div class="fix-left-section-container">
  <div class="share-section mb-4">
    <div class="share-text mb-2">شارك المقال على</div>
    <div class="social-icons d-flex justify-content-end gap-2">
      <a href="#" class="social-icon">
        <i class="fa-brands fa-twitter"></i>
      </a>
      <a href="#" class="social-icon">
        <i class="fa-brands fa-facebook-f"></i>
      </a>
    </div>
  </div>

  <div class="watch-also-wrapper position-relative">
    <div class="green-backdrop"></div>
    <div class="gray-content-card">
      <h4 class="section-title mb-4">شاهد ايضا</h4>
      <ul class="custom-list p-0 m-0">
        <li>
          <a [routerLink]="'/Egyptions'" routerLinkActive="active"> وحده رعاية المستثمرين المقيمين فى الخارج </a>
        </li>

        <li>
          <a [routerLink]="'/Performance'" routerLinkActive="active"> الأداء الإقتصادى</a>
        </li>
      </ul>
    </div>
  </div>
</div>